import { Box, Button, Stack, Typography } from "@mui/material";

export type ErrorDisplayProps = {
  /** The primary message to display  */
  primaryMessage: string;

  /** The secondary message to display  */
  secondaryMessage?: string;

  /** Boolean to display page reload button */
  showReloadOption?: boolean;
};

/**
 * Component used to display a message and image when there is no content to display.
 * Optionally display a secondary message.
 */
export const ErrorDisplay = ({
  primaryMessage,
  secondaryMessage,
  showReloadOption = false,
}: ErrorDisplayProps) => (
  <Stack alignItems="center" gap={2}>
    <Box
      component="img"
      src="/empty-truck.png"
      alt="Empty Daylight Truck"
      aria-hidden
      sx={{ width: 374 }}
    />
    <Typography
      variant="h4"
      color="text.disabled"
      maxWidth={700}
      textAlign="center"
    >
      {primaryMessage}
    </Typography>
    {secondaryMessage && (
      <Typography
        variant="h6"
        color="text.disabled"
        maxWidth={700}
        textAlign="center"
      >
        {secondaryMessage}
      </Typography>
    )}
    {showReloadOption && (
      <Box>
        <Button
          size="large"
          variant="contained"
          onClick={() => window.location.reload()}
          sx={{
            backgroundColor: "primary.main",
            color: "white",
            paddingInline: 2.75,
            paddingBlock: 1,
            fontSize: 15,
          }}
        >
          Reload Page
        </Button>
      </Box>
    )}
  </Stack>
);
